"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AskSidWidget = function (_React$Component) {
  (0, _inherits3.default)(AskSidWidget, _React$Component);

  function AskSidWidget() {
    (0, _classCallCheck3.default)(this, AskSidWidget);
    return (0, _possibleConstructorReturn3.default)(this, (AskSidWidget.__proto__ || (0, _getPrototypeOf2.default)(AskSidWidget)).apply(this, arguments));
  }

  (0, _createClass3.default)(AskSidWidget, [{
    key: "script",
    value: function script() {
      return "(function(d, s) {\n      var js;\n      var fjs = d.getElementsByTagName('script')[0];\n      js = d.createElement('script');\n      js.setAttribute('defer', 'true');\n      js.src = \"" + this.props.params.src + "\";\n      fjs.parentNode.insertBefore(js, fjs); })(document);";
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.params.enabled) {
        return _react2.default.createElement("div", null);
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement("div", { id: "as-wc-id", className: "as-wc" }),
        _react2.default.createElement("script", { type: "text/javascript", dangerouslySetInnerHTML: { __html: this.script() } })
      );
    }
  }]);
  return AskSidWidget;
}(_react2.default.Component);

exports.default = AskSidWidget;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AskSid/index.js
// module id = 2267
// module chunks = 0